import {
  pluralizeDays,
  pluralizeHours,
  pluralizeMinutes,
} from 'src/utils/pluralizeUtils';

export const secondsToString = (seconds: number) => {
  const fullDays = Math.floor(seconds / 3600 / 24);
  const fullHours = Math.floor((seconds / 3600) % 24);
  const fullMinutes = Math.floor((seconds / 60) % 60);
  const stringDays = fullDays ? `${fullDays} ${pluralizeDays(fullDays)} ` : '';
  const stringHours = fullHours
    ? `${fullHours} ${pluralizeHours(fullHours)} `
    : '';
  const stringMinutes = fullMinutes
    ? `${fullMinutes} ${pluralizeMinutes(fullMinutes)}`
    : '';
  return stringDays + stringHours + stringMinutes;
};
